import cntl from "cntl";
import React from "react";

const headerWrapperStyles = ({
  headerTitle = undefined,
  className = "",
}) => cntl`
  flex 
  ${headerTitle && "justify-between pb-2 pl-4 bg-green-700"}
  ${!headerTitle && "border-t border-l border-r justify-end"}
  rounded-t-lg
  pt-2
  pr-2
  ${className}
`;

const headerTitleStyles = cntl`
  text-white
  font-medium
  text-lg
`;

const PopupHeader = ({ closePopup, headerTitle, className }) => {
  return (
    <div className={headerWrapperStyles({ headerTitle, className })}>
      {headerTitle && <h3 className={headerTitleStyles}>{headerTitle}</h3>}
      <svg
        onClick={closePopup}
        className="cursor-pointer"
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M3.75732 4.70062L4.70013 3.75781L7.99996 7.05764L11.2998 3.75781L12.2426 4.70062L8.94277 8.00045L12.2426 11.3003L11.2998 12.2431L7.99996 8.94326L4.70013 12.2431L3.75732 11.3003L7.05716 8.00045L3.75732 4.70062Z"
          fill={headerTitle ? "white" : "#0F0F0F"}
        />
      </svg>
    </div>
  );
};

export default PopupHeader;
